import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
    // Component that instantaneously scrolls to the top of a page upon navigation to it
    const { pathname } = useLocation();
  
    useEffect(() => {
      document.documentElement.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant",
      });
    }, [pathname]);

    console.log("Scrolled to top");
}

export default ScrollToTop;